export async function waitForMillis(millis: number): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, millis));
}

export async function waitForTransitionEnd(el: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    el.addEventListener('transitionend', () => resolve(), { once: true });
  });
}
